export const DownChevronIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0001 14.9519L6.44238 9.39415L7.24816 8.58838L12.0001 13.3711L16.777 8.59415L17.5578 9.39993L12.0001 14.9519Z" fill="white" />
    </svg>
  )
}
